import { AutoAwesomeMosaic as AutoAwesomeMosaicIcon } from '@mui/icons-material';
import { Button, Grid } from '@mui/material';
import { set } from 'lodash';
import { type Path } from 'react-hook-form';
import {
  InputWidget,
  NumberInputWidget,
  SwitchButtonWidget,
} from 'src/components/widget';
import { LineupWidget } from 'src/components/widget/lineupWidget';
import { useGetTheme } from 'src/features/components/editComponentPage/forms/FormSelector.hook';
import { type IGcfProductListConfig } from 'src/interfaces/Product';
import { lang } from 'src/utils';

import { Divider } from '../../ProductsSidebar.styled';
import { CategoryItemDescription } from '../categoryItemDescription';
import { CategoryItemTitle } from '../categoryItemTile/CategoryItemTitle';
import { CategoryItemProps } from './CategoryItem.interface';
import { CategoryContainer } from './CategoryItem.styled';

export const CategoryItem = (props: CategoryItemProps) => {
  const showRemoveGroupButton =
    props.showComponents.showRemoveGroupButton &&
    !props.showComponents.enableColumnList;

  const handleFieldChange =
    (field: Path<CategoryItemProps['group']>) => (value: unknown) => {
      props.handleGroupChange('update')(set({ ...props.group }, field, value));
    };

  const currentTheme = useGetTheme(props.themeId);
  const productList = (props.componentConfig?.productList ??
    {}) as IGcfProductListConfig;

  return (
    <CategoryContainer container spacing={2}>
      {props.showComponents.showGroupController && (
        /* 
          TODO: Move the group controller section to a new file
        */
        <>
          <CategoryItemTitle
            value={props.group?.config?.groupHeader}
            handleTitleChange={handleFieldChange('config.groupHeader')}
            theme={currentTheme}
            subHeaderComponentConfig={productList?.groupHeader?.styles}
          />
          <Divider />
          <Grid item xs={12}>
            <CategoryItemDescription
              value={props.group.config?.groupHeader?.description}
              handleDescriptionChange={handleFieldChange(
                'config.groupHeader.description',
              )}
              theme={currentTheme}
              subHeaderDescriptionComponentConfig={
                productList?.groupHeader?.styles?.description
              }
            />
          </Grid>
          <Divider />

          {props.showComponents.showGroupComboController && (
            <>
              <Grid item xs={12}>
                <SwitchButtonWidget
                  label={lang.comboOrderNumber}
                  value={props.group.config.displayOrder}
                  onChange={handleFieldChange('config.displayOrder')}
                />
              </Grid>

              <Grid item xs={6}>
                <NumberInputWidget
                  label={lang.column}
                  value={props.group?.config?.column}
                  onChange={handleFieldChange('config.column')}
                />
              </Grid>

              <Grid item xs={6}>
                <NumberInputWidget
                  label={lang.offsetTop}
                  value={props.group?.config?.offsetTop}
                  onChange={handleFieldChange('config.offsetTop')}
                  options={{ suffix: 'px' }}
                />
              </Grid>

              <Grid item xs={12}>
                <InputWidget
                  value={props.group?.config?.productOrderOverride}
                  label={lang.productOrderOverride}
                  onChange={handleFieldChange('config.productOrderOverride')}
                />
              </Grid>
            </>
          )}
        </>
      )}

      <Grid item xs={12}>
        <LineupWidget
          hideDeleteButton={props.hideDeleteButton}
          showComponents={props.showComponents}
          componentType={props.componentType}
          groupNumber={props.group.order}
          productCategoryIDs={props.productCategoryIDs}
          group={props.group}
          themeId={props.themeId}
          handleGroupChange={(method, group) =>
            props.handleGroupChange(method)(group)
          }
          componentConfig={props.componentConfig}
        />
      </Grid>

      {showRemoveGroupButton && (
        <Grid item xs={12}>
          <Button
            color="error"
            variant="outlined"
            onClick={() => props.handleGroupChange('delete')(props.group)}
            startIcon={<AutoAwesomeMosaicIcon />}>
            {lang.removeCategory}
          </Button>
        </Grid>
      )}
    </CategoryContainer>
  );
};
